import React from 'react';

export default (props) => <button type="submit" className="button button-green">{props.text}</button>;
